import React from "react";
import { Link } from "react-router-dom";
import heroBanner from "../../../assets/img/hero_banner.jpg";
import gisLogo from "../../../assets/img/GIS_logotype_reversed.svg";

import phrasebookLoad from "../../../i18n";
const phrasebook = phrasebookLoad();

const backgroundImage = heroBanner;
export const ContentBox = (props) => {
  return (
    <div className="container px-0 px-lg-2 py-0">
      <div
        className="d-flex bg-cover p-0 p-xs-1 p-sm-2 mb-2"
        style={{ backgroundImage: "url(" + backgroundImage + ")" }}
      >
        <div
          className="bg-light-blue-95 text-white p-1 p-sm-2 mr-auto"
          style={{ maxWidth: "480px" }}
        >
          {/* KC-removing below text */}

          {/* <img src={gisLogo} alt="" /> */}
          <h2>{props.intro}</h2>
          <h4>{props.text1}</h4>
          <h4>{props.text2}</h4>
          {props.location ? (
            <Link className="btn btn-main" to={"" || props.location}>
              {props.info}
            </Link>
          ) : null}
        </div>
      </div>
    </div>
  );
};
